import { action } from 'mobx';
import { AnalyticsStore, Store } from 'bernie-plugin-mobx';

import { Logger, NOOP_LOGGER } from 'bernie-logger';
import { SerializedData } from 'bernie-core';

import { Payload } from './adobe-payload';

export class AnalyticsPayloadStore extends Store {
  public apolloLinkSetOnServer = false;
  public apolloLinkSetInBrowser = false;

  public data: { payload: Payload[] } = { payload: [] };

  /* tslint:disable:unnecessary-constructor */
  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public addPayload(payloadToPush: Payload): void {
    this.data.payload.push(payloadToPush);
  }

  @action
  public publishPayload(analyticsStore: AnalyticsStore): void {
    if (this.data.payload.length > 0) {
      analyticsStore.publishClientSidePayload(this.data.payload);
      this.data.payload = [];
    }
  }
}
